import Range from './Range';

const Input = () => {
  return null;
};

Input.Range = Range;

export default Input;
